import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const badges = ['800+ Pages of Proven Systems', '1,000+ Ready-to-Use Prompts', 'Used by Top Agents in 4 Countries'];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-navy-900" data-id="element-41" data-mp="4lyswf6y22ah">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-[radial-gradient(1200px_600px_at_15%_-10%,#234A66_0%,transparent_60%),radial-gradient(900px_500px_at_100%_100%,#153044_0%,transparent_55%)]" data-id="element-42" data-mp="4jm7tt5w3bt7" />
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 grid-pattern opacity-40" data-id="element-43" data-mp="sb1chsl5257m" />

      <div className="relative mx-auto max-w-5xl px-5 sm:px-6 lg:px-8" style={{
      paddingTop: "12px",
      paddingBottom: "12px"
    }} data-id="element-44" data-mp="ncq1hej3xont">
        <motion.div initial={{
        opacity: 0,
        y: 22
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-45" data-mp="3d33ecx6girk8">
          <p className="mb-6 inline-flex w-full items-center justify-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs font-semibold text-slate-200 sm:w-auto sm:px-16" style={{
          fontWeight: "800",
          paddingTop: "11px",
          paddingBottom: "11px",
          marginTop: "0px",
          marginBottom: "0px"
        }} data-id="element-46" data-mp="3j9ah3d0igq55">
            <ShieldCheckIcon aria-hidden="true" className="h-4 w-4 text-brand-gold" data-id="element-47" data-mp="30gzvcvxzn8u9" />
            KODA DIGITAL
          </p>

          <h1 className="text-white" style={{
          fontSize: "24px",
          fontWeight: "800"
        }} data-id="element-48" data-mp="35a2gqgsm3bzd">
            <span className="block text-[26px] leading-[1.15] tracking-tight sm:text-4xl lg:text-5xl" data-id="element-49" data-mp="2qhqwboo9n411">
              THE TRADITIONAL AGENT IS DYING. <span className="text-brand-gold" data-id="element-50" data-mp="2hinbaf5jgejw">THE AI-POWERED ARCHITECT IS TAKING THE MARKET.</span>
            </span>
            <span className="mt-4 block text-base font-medium leading-relaxed text-slate-300 sm:text-lg" style={{
            marginTop: "0px",
            marginBottom: "0px",
            paddingTop: "0px",
            paddingBottom: "0px",
            width: "328px",
            height: "56px"
          }} data-id="element-51" data-mp="2ljpcv2mxh2p1">
              The rules of Real Estate just changed forever. You are either the one using the engine, or the one being crushed by it.
            </span>
          </h1>

          <motion.figure className="relative mt-8 sm:mt-10" initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3,
          delay: 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-52" data-mp="de6ost7x25lu">
            <div className="overflow-hidden rounded-2xl border border-white/10 shadow-2xl ring-1 ring-brand-gold/20" data-id="element-53" data-mp="111ol9224lrv5">
              <img src="https://cdn.magicpatterns.com/uploads/bS9CBFjnd5mFrWa2H7s2Tq/comprimido-1x1.jpg" alt="Real estate agent on a luxury balcony with AI data visualizations mapping a modern property" className="h-full w-full object-cover object-[30%_center] aspect-[4/3] sm:aspect-[16/9] sm:object-center" width={1386} height={775} loading="eager" style={{
              paddingTop: "0px",
              paddingBottom: "0px",
              marginTop: "0px",
              marginBottom: "0px",
              height: "301px"
            }} data-id="element-54" data-mp="x0l48c8cdpsc" />
            </div>
          </motion.figure>

          <p className="mt-8 text-base leading-relaxed text-slate-300 sm:text-center sm:text-lg" style={{
          marginTop: "0px",
          marginBottom: "0px"
        }} data-id="element-55" data-mp="268g468c4awp9">
            The 800+ page system that turns real estate agents into autonomous, deal-closing machines — built for
            the market you are actually selling in today.
          </p>

          <div className="flex flex-col items-stretch gap-3 sm:items-center" data-id="element-56" data-mp="2p0h83p3r1d5j">
            <CTAButton href="#offer" className="w-full sm:w-auto" data-id="element-57" data-mp="2oye7yc8vu3n3">
              <span className="block" style={{
              fontSize: "20px"
            }} data-id="element-58" data-mp="2tyadwh15455a">Discover what&rsquo;s inside</span>
              <span className="block" style={{
              fontSize: "20px"
            }} data-id="element-59" data-mp="unrc91ttltvi">See the complete system</span>
            </CTAButton>
            <p className="text-center text-sm text-slate-400" style={{
            fontSize: "12px"
          }} data-id="element-60" data-mp="zlsvpnv5rv7i">
              Join <span className="font-semibold text-slate-200" data-id="element-61" data-mp="4d77r7budg2f">2,000+ agents</span> who&rsquo;ve already
              transformed their business.
            </p>

            <ul className="mt-1 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 pb-4" data-id="element-62" data-mp="e88s7pv69tyo">
              {badges.map(badge => <li key={badge} className="flex items-center gap-1.5 text-[13px] font-semibold leading-tight text-slate-200" data-id="element-63" data-mp="98e4twalvmid">
                  <CheckIcon aria-hidden="true" className="h-3.5 w-3.5 shrink-0 text-brand-gold" data-id="element-64" data-mp="3cr7c5rcsjf43" />
                  {badge}
                </li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </header>;
}